// extracted by mini-css-extract-plugin
export var bounce = "_jw-1";
export var generatingText = "_jw-6";
export var lightning = "_jw-4";
export var popup = "_jw-5";
export var progressBar = "_jw-7";
export var progressFill = "_jw-8";
export var progressShimmer = "_jw-9";
export var progressText = "_jw-a";
export var shimmer = "_jw-3";
export var uploadIcon = "_jw-0";
export var uploadingText = "_jw-2";